import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { EngagementSuiteV2 } from './EngagementSuiteV2';
import { OktaAuthReact } from '@amzn/ring-cs-okta-auth-client';
import UnauthorizedUser from './UnauthorizedUser';
import settings from '../settings.json';
// Styling Imports
import '../components/layouts/font-face.css';

// prep this site to use Okta
const { okta: { iss, cid } } = (settings as any)[window.location.host] || settings.default;
export const {
    ContinuousAuthProvider,
    useAuthState,
    useContinuousAuth,
    login,
    logout,
    getHeaders,
} = new OktaAuthReact(iss, cid);

function App() {
    return (
        <Routes>
            <Route path='/' element={<EngagementSuiteV2 />} />
			<Route path='/unauthorized' element={<UnauthorizedUser />} />
		</Routes>
    );
}

export default App;